import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import moment from 'moment';
import Cookie from 'js-cookie';
import { store } from '@ice/stark-data';
import { appHistory } from '@ice/stark-app';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
  Form,
  Search,
  Input,
  Button,
  DatePicker,
  Balloon,
  Select,
  TimePicker,
  Radio,
  Message,
  Icon
} from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import LzDialog from '@/components/common/LzDialog';
// import BigPromotionPrompt from '@/components/UI/BigPromotionPrompt';

// import SmsShortlink from '@/components/sms/insertLink';
// import Phoneform from '@/components/sms/phoneform';
// import TestSMSRecord from '@/components/sms/testSMSRecord/sendDetail';
// import SmsTemplate from '@/components/sms/smsTemplate';
import Dialog_CrowdSmsTemplate from '@/components/CrowdSmsTemplate';
// import SecondCheckDialog from '@/components/SecondCheckDialog/SecondChecDialogCanvas';
// import SecondCheckContentDialog from '@/components/sms/SecondCheckContentDialog';
import { CanvasService, Servlets } from '@/service';
// import useGetPoList from '@/hooks/public/useGetPoList';
// import UseTestMsg from '@/hooks/public/useTestMsg';
// import specialchar from './utils';

import phone from '@/assets/images/CanvasImages/phone.png';
import utils from '@/common/utils';
import LzTextarea from '@/components/common/LzTextarea';
import styles from '../../../index.module.scss';
import { ActivityContext, PageType } from '../../../../Edit';
// import checkCrowdBlack from '@/components/sms/FilterCondition/indexnew';
// import FilterCondition from '@/components/sms/FilterCondition/FormNew';
import CONSTANTS from '@/utils/constant';
import icon_warning from '@/pages/OrderSelection/icon/iconWarning.svg';

// 退订文案长度
const CANCELWDLENGTH = CONSTANTS.LZ_SMS_CANCEL_WORD.length + 3; // 3是文案前的空格和签名的中括号

export default ({
  allNodeData = [],
  activityInfo = {},
  prevNodes = [],
  initData = {},
  runState = {},
  currentNode = {},
  changeData = (data) => { },
  onCancel = () => { },
  validate = () => { },
  getAllNodeIds = [],
}) => {
  const { graph } = useContext(ActivityContext);
  const RadioGroup = Radio.Group;

  // 组件内部的数据
  const [data, setData] = useState({});
  // 短链接弹窗是否展示
  // const [showShortLink, setShow] = useState(false);
  // 插入链接内容
  // const [insertSmsLink, setInsertSmsLink] = useState('');
  // 短链接
  const [shortLink, setShortLink] = useState('');
  // 长链接
  const [longLink, setLongLink] = useState('');
  // 短信内容
  const [smsContent, setSMSContent] = useState('');
  // 所选短信模板内容
  const [smsTemplateCont, setSmsTemplateCont] = useState('');
  // 短信内容长度
  const [everyMessageNum, setEveryMessageNum] = useState(1);
  // 测试手机号
  const [testPhone, setTestPhone] = useState([]); // 准备要发送测试短信的手机号
  const [testPhoneList, setTestPhoneList] = useState([]); // 下拉框的选项手机号
  const [testTel, setTestTel] = useState(''); // 测试短信的手机号

  // 修改测试手机号弹窗相关
  // const [phoneModule, setPhoneModule] = useState(false);

  // 选择短信模板相关
  const [templateDia, setTemplateDia] = useState(false);

  // 获取测试短信发送记录
  // const [testListModule, setTestListModule] = useState(false);

  // 二次确认弹窗，这里是为宝洁专门开通的确认功能，请后续维护人员注意
  // const [secondCheckDialog, setSecondCheckDialog] = useState(false);
  // const [PGSecondData, setPGSecondData] = useState({});

  // 已输入字数
   const [sizeLength, setSizeLength]= useState(0);
  // 短信条数
  const [smsNum, setSmsNum] = useState(0);
  // 选择短信模板的时候，计数
  // const [smsTemplateCount, setSmsTemplateCount] = useState(0);

  // Disable all dates before today
  const currentDate = new Date(new Date().setDate(new Date().getDate() - 1));
  const currentHour = new Date(currentDate.setHours(new Date().getHours() - 1));
  const disabledHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23]; // 整个活动设置的是以零次2点开始，短信节点执行时间点所需禁用的时间
  const cycleSeconedType = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]; // 整个活动设置的是以下午14点开始，短信节点执行时间点所需禁用的时间
  const [customDisabledHours, setCustomDisabledHours] = useState([]); // 整个活动设置的是自定义时间，短信节点执行时间点所需禁用的时间--时
  const [customDisabledMins, setCustomDisabledMins] = useState([]); // 整个活动设置的是自定义时间，短信节点执行时间点所需禁用的时间--分
  const [firstHourDisabledMins, setFirstHourDisabledMins] = useState([]);
  const [lastHourDisabledMins, setLastHourDisabledMins] = useState([]);
  const defaultTimeValue = moment('09:00:00', 'HH:mm:ss', true);
  const disabledItems = (list) => (index) => {
    return list.indexOf(index) >= 0;
  };
  const disabledDate = function (date, view) {
    return date.valueOf() < currentHour.valueOf();
  };
  const remainingDay = store.get('remainingDay');
  // 单次任务 定时执行 默认开始时间
  const disabledStartDate = function (date, view) {
    const endDate = new Date(new Date().setDate(new Date().getDate() + remainingDay)).getTime();
    const currentDate = new Date(new Date().setDate(new Date().getDate() - 1)); // 当前日期的前一天
    return date.valueOf() < currentDate.valueOf() || date.valueOf() > endDate;
  };

  // 计算到底取哪个时间值，现在的规则是：单次活动，如果是指定时间执行的任务，第一次打开弹窗就取指定时间+20分钟为默认短信节点执行时间，如果是立即执行的任务，就取当前时间+20分钟
  const calcTime = () => {
      let time = ((activityInfo.executionPlan.crowdStartTime && activityInfo.executionPlan?.crowdStartTime > new Date().getTime()) ? activityInfo.executionPlan.crowdStartTime : new Date().getTime()) + 20 * 60 * 1000;
      if (new Date(time).getHours() >= 20) {
          time = new Date(time).setHours(19, 59, 0);
      }
      return time;
  }
  /**
   * 获取本账号的短信签名和短信余额
   */
  const getAccountInfo = async () => {
    let smsCount = 0;
    let smsSign = '';
    const formData = { ...initData };
    // 转换时间 type: 1-单次 2-循环
    if (activityInfo.executionPlan.type === 1) {
      formData.executionTime = formData.executionTime
        ? moment(formData.executionTime).format('YYYY-MM-DD HH:mm:ss')
        : moment(calcTime()).format('YYYY-MM-DD HH:mm:ss')
    } else {
      formData.executionTime = formData.executionTime
        ? `${(formData.executionTime - formData.executionMinute * 60000) /
        3600000
        }:${formData.executionMinute}`
        : `${activityInfo.executionPlan.startHour}:${activityInfo.executionPlan.startMinute + 20}`; // 循环执行的活动，填写的是延时小时分钟，获取毫秒值转为小时数
      if (activityInfo.executionPlan.startHour === 2) {
        formData.excludedByDayCount = 2;
      }
    }
    // 循环方式必传给后端
    formData.cycleType = activityInfo.executionPlan.type;
    // 转换短链接
    if (formData.shortLink) {
      formData.smsContent = formData.smsContent.replace(
        '#oldshortLink',
        `${formData.shortLink}`
      );
      setLongLink(formData.url);
      setShortLink(formData.shortLink);
    }

    // 现已经没有回t退，且拒收文案已经在短信模板里，所以不再自己处理
    // formData.smsContent = formData.smsContent.replace(' 回T退', '').replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, '');
    // 获取账号信息
    smsCount = await Servlets('getTitle', {}).catch((e) => {
      console.log(e);
    });
    await Servlets('getSmssign', { shopName: smsCount?.data?.shopName }).then((res: { data: string }) => {
      if(res.success) {
        formData.smsSign = res.data;
      }
    }).catch((e) => {
      console.log(e);
    });
    formData.smsCount = smsCount?.data?.smsTotal;
    // formData.smsSign = smsCount?.data?.shopName;
    setCurrentBalance(smsCount?.data?.smsTotal);
    setEveryMessageNum(
      Math.ceil((formData.smsContent.length + formData.smsSign.length + CANCELWDLENGTH) / 70)
    );
    setData({ ...formData });

    // 实时拼接出手机模型展示的内容
    const sign = formData.smsSign ? `【${formData.smsSign}】` : '【】';
    let cont = formData.smsContent ? formData.smsContent : CONSTANTS.LZ_SMS_CANCEL_WORD;
    cont = cont?.replace(/\n/g, '<br/>');
    cont = cont?.replace(/\s/g, '&nbsp;');
    setSMSContent(`${sign + cont}`);
  };

  /** 获取短信余额 */
  const [currentBalance, setCurrentBalance] = useState(0); // 商家当前短信余额
  const getPaymentRecord = (isReFresh = false) => {
    Servlets('getPageSmsNum').then((res: { data: number }) => {
      if (res.data === undefined) {
        return;
      }
      setCurrentBalance(res.data);
      if (isReFresh) Message.success('余额已刷新');
    });
  };
  /** 立即充值 */
  const immediatelyPrepaid = () => {
    console.log(window.location);
    window.open('../../../../accountKeeper');
  };
  /** 刷新余额 */
  const refreshPrepaid = () => {
    getPaymentRecord(true);
  };

  /**
   * 获取测试短信接收手机号
   */
  // const getTestNumInfo = async () => {
  //   CanvasService.getSignphone()
  //     .then((res: any) => {
  //       setTestPhoneList(JSON.parse(JSON.stringify(res.data)));
  //       setTestPhone([res.data[0].phone]);
  //       const phoneNumArr = [];
  //       res.data.forEach((item) => {
  //         phoneNumArr.push(item.phone);
  //       });
  //     })
  //     .catch((e) => console.log(e));
  // };

  /**
   * 刷新短信余额
   */
  const frashCount = () => {
    Servlets('getTitle', {}).then((res) => {
      if (res.success) {
        LzMsg.success('刷新成功');
      }
        onChange({ smsCount: res.data.smsTotal });
    });
  };

  /**
   * 选择短信模板，替换到本弹窗form表单内
   * @param tmp-本模板所有内容，包括长短链接等
   */
  const dealSmsContent = (tmp) => {
    let templateCont = tmp.templateContent;
    // 有可能选择的是历史短信，所以需要把短信内容的占位符替换成短链接
    // if (~templateCont.indexOf('#oldshortLink')) {
    //   templateCont = templateCont.replace('#oldshortLink', tmp.shortLink);
    // }
    setSizeLength(tmp.smsSplitNum ? tmp.smsSplitNum.split('/')[0]:0);
    const len = tmp.smsSplitNum ? tmp.smsSplitNum.split('/')[1]:data.smsNum;
    setSmsNum(len);
    onChange({
      smsContent: templateCont,
      shortLink: tmp.shortLink,
      url: tmp.longLink,
      smsModelId: tmp.templateId,
      smsAccount: tmp.smsAccount, // 莫名其妙的参数
      smsNum: len,
    }); // 改变data中存储的短链和短信内容
    setShortLink(tmp.shortLink); // 本页面短链接暂存
    setLongLink(tmp.longLink); // 本页面长链接暂存
    setSmsTemplateCont(templateCont); // 所选短信模板内容暂存
    setTemplateDia(false);
    // 使自定义的文本组件内容更新，生成span标签
    // setSmsTemplateCount((x) => x + 1);
  };

  /**
   * 计算短信内容的字数
   */
  const getSMSwords = () => {
    const signLength = data.smsSign ? data.smsSign.length : 0;
    return signLength + sizeLength + CANCELWDLENGTH;
  };

  // 初始化表单数据 后端需要时间戳格式，需在表单内部自己维护
  useEffect(() => {
    // 当新增营销活动时，循环方式为循环执行，并且执行起始时间点选择的自定义时间
    // 则根据自定义时间计算短信发送时间不可选的时和分
    // 发送时间限制在自定义时间的两小时内，最晚不超过19点50
    if (activityInfo.executionPlan.type === 2) {
      // 不可点击的小时：自定义时间的小时~19点之间可点击，其余不可点击
      for (let i = 0; i < activityInfo.executionPlan.startHour; i++) {
        customDisabledHours.push(i);
      }
      for (let i = 20; i < 24; i++) {
        customDisabledHours.push(i);
      }
      setCustomDisabledHours(customDisabledHours);
      // 可以点击的小时的第一个，对应不可点击的分钟：不可点击的分钟为0~startMinute之间的分钟
      for (let i = 0; i < activityInfo.executionPlan.startMinute; i++) {
        firstHourDisabledMins.push(i);
      }
      setCustomDisabledMins(firstHourDisabledMins);
      setFirstHourDisabledMins(firstHourDisabledMins);
      // 可以点击的小时的最后一个，对应不可点击的分钟：不可点击的分钟为50分~60分
      for (let i = 51; i < 60; i++) {
        lastHourDisabledMins.push(i);
      }
      setLastHourDisabledMins(lastHourDisabledMins);
    }
    getAccountInfo();
    // getTestNumInfo();
  }, []);

  useEffect(() => {
    // getSMSwords();
    // 实时拼接出手机模型展示的内容
    // const sign = data.smsSign ? `【${data.smsSign}】` : '【】';
    let cont = data.smsContent ? data.smsContent : '';
    cont = cont?.replace(/\n/g, '<br/>');
    cont = cont?.replace(/\s/g, '&nbsp;');
    const val = cont ? `【${data.smsSign}】${cont}` : `【${data.smsSign}】 ${CONSTANTS.LZ_SMS_CANCEL_WORD}`;
    setSMSContent(`${val}`);
  }, [data.smsContent, data.sign]);

    // 实时获取最新短信执行时间【定时执行类型】
    const getExecutionTime = useMemo(() => {
        const res = data.executionTime === ''
            ? moment(calcTime()).format( // 20230919修改，原型优化体现--默认时间要比画布开始执行时间多20分钟
                'YYYY-MM-DD HH:mm:ss'
            )
            : data.executionTime
        return res
    }, [activityInfo.executionPlan.crowdStartTime, data.executionTime]);

  /**
   * 合并新旧状态
   */
  const onChange = (newData) => {
    setData({
      ...data,
      ...newData,
    });
  };

  /** 函数防抖 响应函数 */
  const responseFunc = (func, ...argu) => {
    utils.debounceImmediately(func, 30000)(argu); // 立即执行
  };
  /** 设置测试手机号 value */
  const setTestTelFunc = (val: string): void => {
    setTestTel(val);
  };
  /**
   * 发送测试短信
   */
  const sendTestTel = () => {
    const formData = { ...data };
    if (!testTel) {
      Message.warning('请输入您的手机号码后发送测试！');
    }

    if (!utils.telphoneVerification(testTel)) {
      Message.warning('请正确填写您的手机号码！');
      return;
    }

    const fullContent = {
      fullContent: `${formData.smsContent.replace(' ', '')}`, // ${CONSTANTS.LZ_SMS_CANCEL_WORD}
      mobile: testTel,
      channelType: 1, // 短信类型：0-营销类 1-关怀类
      replace: 1, // 是否手动替换（只有关怀类短信能替换）0-是 1-否。这个对于营销类没什么意义，且现在都不可替换，所以写死1。
      sign: formData.smsSign,
      smsAccount: formData.smsAccount,
      templateId: formData.smsModelId,
      templateParam: '', // 这个参数暂时用不到，后端写死了一个值，前端先传空备用
    };
    Servlets('sendTestsms', fullContent).then((res) => {
      if (res.success) {
        LzMsg.success('发送成功')
      }else {
        LzMsg.error(res.resp_msg);
      }
    }).catch((e) => {
      console.log(e);
      LzMsg.error(e.message);
    });
  };

  useEffect(() => {
    setSizeLength(`【${data.smsSign}】${data.smsContent}`?.length ?? 0);
    setSmsNum(data.smsNum ?? 1);
  }, [data.smsContent, data.smsSign]);

  /**
   * 点击确认
   */
  const confirm = async (secondCheck) => {
    const temp = JSON.parse(JSON.stringify(data));
    const formData = {
      ...data,
    };
    if (data.smsCount < formData.filterMaxMemberCount) {
      LzMsg.error('账户余额不足，请确认余额充足后创建任务');
    }

    if (activityInfo.executionPlan.type === 1) {
      // 活动类型为单次
      /**
       * 校验分为以下四种情形
       *       所新建的活动的画布开始执行时间    短信节点发送时间   是否校验
       * 情形1：     立即执行 0                   立即执行 0       否
       * 情形2：     立即执行 0                   定时执行 1      短信发送时间大于当前时间10分钟
       * 情形3：     定时执行 1                   立即执行 0       否
       * 情形4：     定时执行 1                   定时执行 1      短信发送时间大于当前时间10分钟、短信发送时间大于开始时间10分钟
       */
      const activityExecutionTimeType =
        activityInfo.executionPlan.timeDifference; // 所新建的活动的画布开始执行时间类型
      const smsExecutionTimeType = data.smsTimeDifference; // 短信节点发送时间类型
      if (smsExecutionTimeType === 0) {
        formData.executionTime = 0;
      } else if (smsExecutionTimeType === 1) {
        formData.executionTime = new Date(
          formData.executionTime === ''
            ? moment(new Date().getTime())
            : formData.executionTime
        ).getTime();
        if (activityExecutionTimeType === 0) {
          // 情形2
          if (formData.executionTime < new Date().getTime() + 10 * 60 * 1000) {
            LzMsg.error('短信发送时间应大于当前时间10分钟');
            return false;
          }
        }
        if (activityExecutionTimeType === 1) {
          // 情形4
          const maxTime = Math.max(
            new Date().getTime(),
            activityInfo.executionPlan.crowdStartTime
          );
          if (formData.executionTime < maxTime + 10 * 60 * 1000) {
            LzMsg.error(
              '短信发送时间应大于当前时间10分钟并且大于画布开始执行时间10分钟'
            );
            return false;
          }
        }
      }
    } else {
      const timeArr = formData.executionTime.split(':');
      formData.executionMinute = timeArr[1];
      formData.executionTime = timeArr[0] * 3600000 + timeArr[1] * 60000; // 循环执行的活动，填写的是延时小时数和分钟数，需要转成毫秒值
      // formData.executionTime = formData.executionTime * 3600000 + formData.executionMinute * 60000;
    }
    // 判断短信内容里是否含有短链接（目前拿3.cn进行判断），如果有短链接信息，但是没有长链接，不可保存
    // if (formData.smsContent.indexOf('3.cn/') > -1 && longLink.length <= 0) {
    //   LzMsg.warning(
    //     '请填入由系统自带短链接工具生成的短链，内容中其他渠道生成的短链接会造成发送失败。'
    //   );
    //   return;
    // }
    // 判断短链接前后有没有空格
    // if (
    //   formData.smsContent.indexOf('3.cn') !== -1 &&
    //   formData.smsContent.indexOf(` ${shortLink} `) === -1
    // ) {
    //   LzMsg.warning('短链接前后请添加空格！');
    //   return;
    // }

    // setData({ ...formData });
    try {
      // await checkCrowdBlackContent();
      await Promise.all(
        Object.keys(validate).map(async (validator) => {
          // 最终校验数据是否填写完整，然后提交给全局
          try {
            if (validator in formData) {
              if (validator === 'name') {
                await validate[validator](
                  formData[validator],
                  allNodeData,
                  currentNode,
                  getAllNodeIds
                );
              } else {
                await validate[validator](formData[validator]);
              }
            }
          } catch (e) {
            throw new Error(e);
          }
        })
      );

      // 校验我所要发送的短信内容是否与我选择的模板相符，来判断最终的短信模板id传默认值-1，还是真正的模板id
      // if (formData.smsContent !== smsTemplateCont) {
      //   formData.smsModelId = -1;
      // }
      // 后端需要我们把短链接转换为一个特定标识，然后他们自行替换
      // if (
      //   formData.smsContent.indexOf(formData.shortLink) > -1 &&
      //   formData.shortLink
      // ) {
      //   formData.smsContent = formData.smsContent.replace(
      //     `${formData.shortLink}`,
      //     '#oldshortLink'
      //   );
      // } else {
      //   formData.url = '';
      //   formData.shortLink = '';
      // }

      // formData.smsContent = `${formData.smsContent.replace(
      //   ' ',
      //   ''
      // )}`; // ${CONSTANTS.LZ_SMS_CANCEL_WORD}
      // if (
      //   activityInfo.executionPlan.type === 1 &&
      //   formData.smsTimeDifference === 1
      // ) {
      //   // 单次检查短信发送时间是否在范围内
      //   return CanvasService.checkTime({
      //     pointTime: formData.executionTime,
      //   });
      // } else {
        changeData(formData);
        graph.updateItem(currentNode.nodeId, {
          content: formData.smsContent !== '' ? formData : false,
          executionTime: activityInfo.executionPlan.type === 2 ? `${Math.floor((formData.executionTime - formData.executionMinute * 60000) / 3600000)}:${formData.executionMinute}` : (formData.executionTime ? moment(formData.executionTime).format('YYYY-MM-DD HH:mm:ss') : 0)
        });
      // }
    } catch (e) {
      const ar = e.message.split(':');
      LzMsg.error(ar[ar.length - 1]);
    }
  };

  /**
   * 点击退出
   */
  const cancel = () => {
    onCancel();
  };

  const formItemLayout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 15,
    },
  };

  return (
    <div
      className="sms-editor-dialog"
    >
      <div
        style={{ display: prevNodes.length ? 'none' : 'block' }}
        className={styles['warning-text']}
      >
        请先连接上级节点
      </div>
      <div style={{ display: 'flex',
        maxHeight: document.documentElement.clientHeight * 0.9 - 250,
        overflowY: 'auto',
        marginTop: '30px', }}>
        <Form
          className={`${styles.formDiv} ${styles.sendMessageDiv} canvasDialog`}
          {...formItemLayout}
        >
          <Form.Item
            label="节点名称："
            required
            requiredMessage="请输入节点名称"
          >
            <Input
              name="messageName"
              placeholder="请输入节点名称"
              size="small"
              value={data.name}
              onChange={(name) => onChange({ name })}
              showLimitHint
              maxLength={80}
              trim
            />
          </Form.Item>
          <Form.Item
            label="发送时间："
            required
            requiredMessage="请选择发送时间"
          >
            {/* 循环类型 1-单次 2-循环 */}
            <div style={{ textAlign: 'left' }}>
              {activityInfo.executionPlan.type === 1 && (
                <>
                  {/* 单次活动时间分为立即执行和指定时间 */}
                  <RadioGroup
                    value={data.smsTimeDifference}
                    onChange={(smsTimeDifference) =>
                      onChange({ smsTimeDifference })
                    }
                    aria-labelledby="groupId"
                  >
                    <Radio id="0" value={0}>
                      立即执行
                    </Radio>
                    <Radio id="1" value={1}>
                      指定时间
                    </Radio>
                  </RadioGroup>
                  <br />
                  {data.smsTimeDifference === 1 && (
                    <DatePicker
                      style={{ marginTop: '10px' }}
                      showTime
                      followTrigger
                      hasClear={false}
                      value={getExecutionTime}
                      onChange={(executionTime) => onChange({ executionTime })}
                      disabledDate={disabledStartDate}
                    />
                  )}
                  <div style={{ marginTop: '10px' }}>
                    说明:
                    <br />
                    1、选择立即执行时，短信会在画布执行到短信节点时立即发送
                    <br />
                    2、选择指定时间时，请注意短信的发送时间需要在画布的执行时间之后10~20分钟
                    <br />
                    3、画布执行时间包含了人群运算的时间，如果短信设置的过早，任务或因为人群未运算好而导致任务异常
                  </div>
                </>
              )}
              {activityInfo.executionPlan.type === 2 && (
                <>
                  <TimePicker
                    hasClear={false}
                    followTrigger
                    className="time-select-input"
                    disabledMinutes={disabledItems(customDisabledMins)}
                    disabledHours={disabledItems(
                      activityInfo.executionPlan.startHour === 2
                        ? disabledHours
                        : activityInfo.executionPlan.startHour === 14 &&
                          activityInfo.executionPlan.startMinute === 0
                          ? cycleSeconedType
                          : customDisabledHours
                    )}
                    format="H:mm"
                    value={data.executionTime ? data.executionTime : `${activityInfo.executionPlan.startHour}:${activityInfo.executionPlan.startMinute + 20}`}
                    onChange={(val) => {
                      onChange({
                        executionTime:
                          typeof val === 'string' ? val : val.format('H:mm'),
                      });
                      if (
                        val?._d?.getHours() ===
                        activityInfo.executionPlan.startHour
                      ) {
                        setCustomDisabledMins(firstHourDisabledMins);
                      } else if (val._d.getHours() === 19) {
                        setCustomDisabledMins(lastHourDisabledMins);
                      } else {
                        setCustomDisabledMins([]);
                      }
                    }}
                  />
                  <div className={styles.removeNote}>
                    注：短信发送需要前置节点运算完成，请尽量多预留一些前置节点的执行时间,来保证短信可以正常发送，短信发送时间请尽量设置在17:00之后，若前置节点过多，请再适量延后。
                  </div>
                </>
              )}
            </div>
          </Form.Item>
          <Form.Item
            label="短信签名："
            required
            requiredMessage="请申请短信签名"
          >
            <div>
              <Input
                className="formItemWidth"
                name="smsSign"
                value={data.smsSign}
                size="medium"
                disabled
                trim
              />
              <div
                className={`${styles.smsSign} messageCrowd`}
                style={{ display: data.smsSign ? 'none' : 'block' }}
              >
                <Balloon
                  popupStyle={{
                    background: '#fff',
                    color: '#333333',
                    borderRadius: '2px',
                  }}
                  trigger={
                    <span
                      className="iconfont icon-icon4-36"
                      style={{ color: '#FF9900', paddingRight: '5px' }}
                    />
                  }
                  closable={false}
                  align="t"
                >
                  签名审核未通过可能造成短信发送不成功，建议审核通过后创建发送任务
                </Balloon>
                短信签名获取中...
              </div>
            </div>
          </Form.Item>
          <Form.Item
            label="短信内容："
            required
            requiredMessage="请填写短信内容"
          >
            <div>
              {/* <BigPromotionPrompt type='canvas_sms_common_create' /> */}
              {/* <div style={{ textAlign: 'left' }}>
                <Input.TextArea
                  placeholder="请输入短信内容"
                  aria-label="TextArea"
                  style={{
                    width: '100%',
                    paddingTop: '5px',
                    marginRight: '10px',
                  }}
                  className={styles.messageContent}
                  value={data.smsContent}
                  rows={7}
                  disabled
                />
              </div>
              <div style={{ display: 'flex', width: '90%' }}>
                <p style={{ marginRight: '10px' }}>
                  已输入<span className={styles.red}>{getSMSwords()}</span>
                  /329字(包含签名)
                </p>
                <p>
                  当前计费：
                  <span className={styles.red}>
                    {everyMessageNum <= 1 ? 1 : everyMessageNum}
                  </span>
                  条
                </p>
              </div>
              <div
                className={`${styles.displayFlex} ${styles.messageSign} ${styles.shortLink}`}
              >
                <div
                  className={`${styles.makeLink} shortLink`}
                  style={{ lineHeight: '24px' }}
                  onClick={() => setTemplateDia(true)}
                >
                  选择短信模板
                </div>
                <div className="shortLink">
                  短信规则说明
                  <Balloon
                    popupStyle={{
                      background: '#fff',
                      color: '#333333',
                      borderRadius: '2px',
                    }}
                    trigger={
                      <span
                        className="iconfont icon-icon4-33"
                        style={{ paddingLeft: '5px' }}
                      />
                    }
                    closable={false}
                    align="t"
                  >
                    1、每70汉字计一条短信，若超出70字，短信条数计算规则变更为每67字计一条短信（例如：70字计一条短信，140字=67字+67字+6字，计三条短信）；字母和标点符号均算一个汉字。
                    <br />
                    {`2、受短信运营商限制，签名和${CONSTANTS.LZ_SMS_CANCEL_WORD}，包含在字数中。`}
                    <br />
                    3、请确保短链接【前后各加一个空格】,否则智能手机无法打开,使用短链接工具生成的短链已默认增加前后空格。
                    <br />
                    4、请确保每条短信中只有一条短连接，否则无法统计短信发送情况。
                    <br />
                    5、短信内容只能为普通字符，不能包含：【、】、表情符
                    等特殊字符。
                    <br />
                  </Balloon>
                </div>
              </div> */}

              <div className={styles.messageLayout}>
                <div className={styles.setButton}>
                  {/* 21年8月，应对抖音云鹿调整，暂时调整功能 */}
                  {/* <Button type="primary" onClick={handleOpenShortUrlDialog}>短链接工具</Button> */}
                  <Button
                    type="secondary"
                    onClick={() => setTemplateDia(true)}
                  >
                    选择短信模板
                  </Button>
                </div>

                <div style={{ display: 'flex' }}>
                  <Input.TextArea
                    disabled
                    className={'crowd-market-sms-create'}
                    maxLength={350}
                    value={`【${data.smsSign}】${data.smsContent}`}
                  />

                  <div className={styles.textArea}>
                    <div>已输入:{sizeLength}/350 字(包含签名)</div>
                    <div>当前计费：{smsNum <= 1 ? 1 : smsNum}条</div>
                    <Balloon
                      popupClassName="popupClassName"
                      align="t"
                      trigger={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Button
                            type="primary"
                            text
                            style={{ float: 'right' }}
                          >计费及内容规则
                          </Button><img
                            src={icon_warning}
                            alt="提示"
                            style={{ width: 14, height: 14 }}
                          />
                        </div>}
                      closable={false}
                    >
                      <div>
                        <div style={{ fontWeight: 'bold' }}>说明</div>
                        <div>
                          1、70字计一条短信收费，超出70字按67字每条计,一个汉字，字母或者标点都算一个字<br/>
                          2、受短信运营商限制，签名和{CONSTANTS.LZ_SMS_CANCEL_WORD}，包含在字数中<br/>
                          3、请确保短链接【前后各加一个空格】，否则智能手机无法打开，使用短链接工具生成的短链已默认增加前后空格<br/>
                          4、请确保每条短信中只有一条短链接，否则无法统计短信发送情况<br/>
                          5、短信内容只能为普通字符，不能包含：【、】、）、表情符 等特殊字符
                        </div>
                      </div>
                    </Balloon>
                  </div>
                </div>

                <div className={styles.textAreaPrompt}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* <Icon
                      type="email"
                      size="small"
                      style={{ marginRight: '8px', color: '#9CA7B6' }}
                    />
                    <span>预计发送：{selectedCrowdData.size * everyMessageNum}条&emsp;&emsp;</span> */}
                    <span>当前账户余额：<span style={{ color: 'red' }}>{currentBalance}</span>条&nbsp;</span>
                    {/* {
                      selectedCrowdData.size > currentBalance &&
                      <Balloon
                        popupClassName="popupClassName"
                        align="t"
                        trigger={
                          <div className={styles.balanceBox}>
                            <span className={styles.text}>余额不足</span>
                            <img src={icon_warning} alt="提示" style={{ width: 14, height: 14 }}/>
                          </div>
                        }
                        closable={false}
                      >
                        <div>
                          <div style={{ fontWeight: 'bold' }}>说明</div>
                          <div>1、发送100W条以上短信需要审核，审核时间是每日18点</div>
                          <div>2、短信发送时间范围为：早9:01-晚 19:59（日常）</div>
                          <div>3、所有商家每天给同一手机号发送营销短信条数不超过3条，所有商家两天内给同一手机号发送营销短信条数不超过5条，同一商家2天内给同一手机号发送营销短信条数不超过1条</div>
                        </div>
                      </Balloon>
                    } */}
                  </div>

                  <div>
                    <Button
                      type="primary"
                      text
                      onClick={immediatelyPrepaid}
                    >立即充值
                    </Button>&emsp;&emsp;
                    <Button
                      type="primary"
                      text
                      onClick={() => responseFunc(refreshPrepaid)}
                    >刷新余额
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Form.Item>
          {/* <Form.Item label="短信账户：">
            <div className={`formItemWidth ${styles.smsAccount} smsAccountDiv`}>
              <div style={{ marginTop: '4px' }}>
                可用余额{' '}
                <span className={styles.smsCount}>{data.smsCount}</span> 条{' '}
                <span className={styles.globalLink} onClick={frashCount}>
                  {' '}
                  刷新
                </span>
              </div>
            </div>
          </Form.Item> */}
          <Form.Item label="测试接收电话：">
            <div
              className={`${styles.smsAccount} smsAccountDiv smsInput`}
              style={{ display: 'flex' }}
            >
              {/* <Select mode="multiple" value={testPhone} onChange={setTestPhone}>
                {testPhoneList.map((item) => (
                  <Select.Option value={item.phone} key={item.phone}>
                    {item.phoneDesensitization}
                  </Select.Option>
                ))}
              </Select>
              <Button
                type="secondary"
                className={`submit-btn ${styles.ml5} ${styles.mr5}`}
                onClick={() => {
                  responseFunc(sendTestSMS);
                }}
              >
                发送测试
              </Button> */}
              <Input
                showLimitHint
                maxLength={11}
                placeholder="请输入..."
                value={testTel}
                hasClear
                onChange={setTestTelFunc}
                style={{ width: 600, marginRight: 10 }}
              />
              &nbsp;
              <Button
                type="secondary"
                style={{ width: '88px' }}
                onClick={() => responseFunc(sendTestTel)}
              >发送测试
              </Button>
            </div>
          </Form.Item>
        </Form>
        <div
          style={{
            background: `url(${phone})`,
            width: '162px',
            height: '265px',
            padding: '20px',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            margin: '0 40px 0 -40px',
          }}
        >
          <div
            style={{
              marginLeft: '-3px',
              wordBreak: 'break-all',
              height: '100%',
              overflowY: 'auto',
            }}
            dangerouslySetInnerHTML={{ __html: smsContent }}
          />
        </div>
      </div>
      <hr />
      <div style={{ padding: '15px 30px 0 0', height: '60px' }}>
        <Button
          type="primary"
          className={`submit-btn ${styles.w88}`}
          onClick={() => confirm()}
          style={{ float: 'right' }}
        >
          确认
        </Button>
        <Button
          type="normal"
          className={`cancel-btn ${styles.mr10} ${styles.w88}`}
          onClick={cancel}
          style={{ float: 'right' }}
        >
          取消
        </Button>
      </div>

      {/* 选择模板 */}
      <LzDialog
        isFullScreen
        shouldUpdatePosition
        visible={templateDia}
        footer={false}
        title="选择短信模板"
        onCancel={() => setTemplateDia(false)}
        onClose={() => setTemplateDia(false)}
        style={{ width: 1060 }}
      >
        <Dialog_CrowdSmsTemplate
          diySelect={(tem) => dealSmsContent(tem)}
          systemSelect={(tem) => dealSmsContent(tem)}
          historySelect={(tem) => dealSmsContent(tem)}
          modelTypeCode={'S_RQDX'}
        />
      </LzDialog>
    </div>
  );
};
